import { render, staticRenderFns } from "./PreviewSocialShareButtonElement.vue?vue&type=template&id=991a85d6&"
import script from "./PreviewSocialShareButtonElement.vue?vue&type=script&lang=js&"
export * from "./PreviewSocialShareButtonElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports